import { useMutation, useQueryClient } from "@tanstack/react-query";
import { saveVenueToLists } from "common/apis/savedplaces";
import { Storage } from "common/storage";

export function usePostSaveVenue() {
  const accessToken = Storage.getCurrentUserToken();
  const queryClient = useQueryClient();

  const { mutate, data, error, status } = useMutation({
    mutationFn: ({
      listIds,
      venueId,
    }: {
      listIds: number[];
      venueId: number;
    }) => {
      return saveVenueToLists(listIds, accessToken as string, venueId);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["getAllSavedPlaces"],
        exact: false,
      });
      queryClient.invalidateQueries({
        queryKey: ["getSavedList"],
        exact: false,
      });
      // The Scout badge step for this action is recorded server-side on this
      // endpoint's success path, so the new progress only reaches the app when
      // `sync-user` refetches.
      queryClient.invalidateQueries({
        queryKey: ["userSync"],
        exact: false,
      });
    },
  });

  return {
    addToLists: mutate,
    result: data,
    error,
    status,
    isLoading: status === "pending",
  };
}
